import React, { useCallback, useMemo, useState } from 'react';
import type { ActivityType, ActivityFeedFilters } from 'shared/src/api/activity-feed-api-types';
import { useCampaignContext } from '@/features/campaigns/campaign-context';
import { CampaignTopNav } from '@/features/proposals/shared-campaign-nav';
import { PageContentSection, PageSection } from '@/components/layout/layout';
import { campaignOverviewTitle, PageTitle } from '@/features/shared/page-title';
import { ActivityFilterBar } from '@/features/activity/ActivityFilterBar';
import { ActivityFeed } from '@/features/activity/ActivityFeed';

const AVAILABLE_ACTIVITY_TYPES: ActivityType[] = [
  'campaign_change',
  'strategy_change',
  'line_item_change',
  'platform_entity_change',
  'zoho_note',
  'creative_request'
];

export function CampaignActivityPage() {
  const { campaign } = useCampaignContext();

  const defaultFilters = useMemo<ActivityFeedFilters>(
    () => ({ campaignId: campaign.campaign_id }),
    [campaign.campaign_id]
  );

  const [filters, setFilters] = useState<ActivityFeedFilters>(defaultFilters);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');

  const handleClearFilters = useCallback(() => {
    setFilters(defaultFilters);
  }, [defaultFilters]);

  return (
    <div className="flex w-full flex-col">
      <PageTitle title={campaignOverviewTitle(campaign.campaign_name)} />
      <CampaignTopNav />
      <PageSection>
        <PageContentSection>
          <div className="flex h-full flex-col overflow-hidden">
            <div className="shrink-0 border-b border-gray-200 bg-white py-4">
              <ActivityFilterBar
                availableActivityTypes={AVAILABLE_ACTIVITY_TYPES}
                filters={filters}
                onFilterChange={setFilters}
                sortDirection={sortDirection}
                onSortDirectionChange={setSortDirection}
                onClearFilters={handleClearFilters}
              />
            </div>
            <div className="min-h-0 flex-1 overflow-y-auto py-4">
              <ActivityFeed
                filters={filters}
                sortDirection={sortDirection}
                showCampaignName={false}
              />
            </div>
          </div>
        </PageContentSection>
      </PageSection>
    </div>
  );
}
